import React, { useEffect, useState } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
  Box,
  TableContainer
} from "@mui/material";
import api from "../../utils/api";

const GateVisitorsList = ({ clubMemberCode }) => {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVisitors = async () => {
      if (!clubMemberCode) return;

      try {
        const res = await api.get(`/gate-visitors/member/${clubMemberCode}`);
        const sorted = (res.data || []).sort(
          (a, b) => new Date(b.CreatedAt) - new Date(a.CreatedAt)
        );
        setVisits(sorted);
      } catch (err) {
        console.error("Failed to fetch gate visitors:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVisitors();
  }, [clubMemberCode]);

  const formatDateTime = (date) =>
    date ? new Date(date).toLocaleString() : "—";

  const getStatusColor = (status) => {
    switch ((status || "").toLowerCase()) {
      case "approved": return "success";
      case "denied": return "error";
      case "checked-in": return "primary";
      case "checked-out": return "info";
      case "pending": return "warning";
      default: return "default";
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Gate Visitor Records
      </Typography>
      {visits.length === 0 ? (
        <Typography>No visitors found for this member.</Typography>
      ) : (
        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Visitor Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Arrival</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Departure</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Authorized By</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Created At</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visits.map((v, i) => (
                <TableRow
                  key={v.VisitID}
                  sx={{
                    backgroundColor: i % 2 === 0 ? "background.default" : "background.paper"
                  }}
                >
                  <TableCell>{`${v.FirstName || ""} ${v.LastName || ""}`.trim()}</TableCell>
                  <TableCell>{v.Description || "—"}</TableCell>
                  <TableCell>{formatDateTime(v.ArrivalDate)}</TableCell>
                  <TableCell>{formatDateTime(v.DepartureDate)}</TableCell>
                  <TableCell>{v.AuthorizedBy || "—"}</TableCell>
                  <TableCell>{formatDateTime(v.CreatedAt)}</TableCell>
                  <TableCell>
                    <Chip
                      label={v.StatusName || "Unknown"}
                      color={getStatusColor(v.StatusName)}
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default GateVisitorsList;
